import React, { useState } from "react";
import Box from "@mui/material/Box";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SquareIcon from "@mui/icons-material/Square";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link, Outlet, useLocation, useParams } from "react-router-dom";
import navLogo from "../Assets/Images/logo.png";
import logo from "../Assets/Images/pngwing.com.png";
import { NavBar } from "./Navbar/NavBar";
import { generateMenuItems } from "../utils";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import DifferenceOutlinedIcon from "@mui/icons-material/DifferenceOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import CloseIcon from "@mui/icons-material/Close";
import { Avatar, Collapse, IconButton } from "@mui/material";
import Breadcrumb from "./Breadcrumb";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Tooltip from "@mui/material/Tooltip";

export default function HOC() {
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const [open, setOpen] = useState(true); // default closed on small screen
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false); // for large screen icon/full toggle
  const { pathname } = useLocation();
  const params = useParams();
  const [financeGridOpen, setFinanceGridOpen] = useState(true);
  const [financeGridChild, setFinanceGridChild] = useState("");

  const icons = {
    icon3: <ReceiptLongOutlinedIcon sx={{ color: "inherit" }} />,
    icon4: <Inventory2OutlinedIcon sx={{ color: "inherit" }} />,
    icon5: <PaymentOutlinedIcon sx={{ color: "inherit" }} />,
    icon6: <PaymentOutlinedIcon sx={{ color: "inherit" }} />,
    icon7: <FileCopyOutlinedIcon sx={{ color: "inherit" }} />,
    icon8: <DifferenceOutlinedIcon sx={{ color: "inherit" }} />,
    icon9: <EditNoteOutlinedIcon sx={{ color: "inherit" }} />,
    icon10: <ArticleOutlinedIcon sx={{ color: "inherit" }} />,
  };

  const menuItems = generateMenuItems(userDetails, pathname, params, icons);

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Overlay sidebar for small/medium screens */}
      {isSidebarExpanded && (
        <div
          className={`fixed inset-0 z-50 xl:hidden transition-transform duration-300 ${
            isSidebarExpanded ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-300"
            onClick={() => setIsSidebarExpanded(false)}
          ></div>

          {/* Sidebar panel */}
          <aside
            className="relative w-72 bg-gradient-to-b from-white via-gray-50 to-white text-gray-800 p-0 h-full shadow-2xl overflow-y-auto border-r border-gray-200"
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 50%, #ffffff 100%)",
            }}
          >
            <div className="sticky top-0 z-10 bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between shadow-sm">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg flex items-center justify-center shadow-md">
                  <span className="text-white font-bold text-sm">B</span>
                </div>
                <span className="font-semibold text-gray-800">Bulk WorkFlow</span>
              </div>
              <IconButton
                onClick={() => setIsSidebarExpanded(false)}
                sx={{
                  bgcolor: "#f1f5f9",
                  "&:hover": {
                    bgcolor: "#e2e8f0",
                    transform: "rotate(90deg)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                <CloseIcon sx={{ fontSize: 22, color: "#64748b" }}/>
              </IconButton>
            </div>
            {renderSidebarContent(
              menuItems,
              isSidebarExpanded,
              setFinanceGridOpen,
              financeGridOpen,
              financeGridChild,
              setFinanceGridChild,
              pathname,
              userDetails
            )}
          </aside>
        </div>
      )}

      {/* Permanent sidebar for large screens */}
      <aside
        className={`hidden xl:block bg-gradient-to-b from-white via-gray-50 to-white text-gray-800 p-0 shadow-lg transition-all duration-300 border-r border-gray-200 flex-shrink-0 h-screen ${
          open ? "w-72" : "w-20"
        }`}
        style={{
          background: open 
            ? "linear-gradient(180deg, #ffffff 0%, #f8fafc 50%, #ffffff 100%)"
            : "linear-gradient(180deg, #ffffff 0%, #f8fafc 50%, #ffffff 100%)",
        }}
      >
        {open && (
          <div className="sticky top-0 z-10 bg-white border-b border-gray-200 px-4 py-3 flex items-center gap-2 shadow-sm">
            <div className="w-8 h-8 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg flex items-center justify-center shadow-md">
              <span className="text-white font-bold text-sm">B</span>
            </div>
            <span className="font-semibold text-gray-800">Bulk WorkFlow</span>
          </div>
        )}
        {renderSidebarContent(
          menuItems,
          open,
          setFinanceGridOpen,
          financeGridOpen,
          financeGridChild,
          setFinanceGridChild,
          pathname,
          userDetails
        )}
      </aside>

      {/* Main content area with header */}
      <div className="flex flex-col flex-1 overflow-hidden">
        <header className="h-16 bg-gradient-to-r from-white to-gray-50 shadow-lg flex items-center border-b border-gray-200 relative z-10 flex-shrink-0">
          <NavBar
            open={open}
            setOpen={setOpen}
            isSidebarExpanded={isSidebarExpanded}
            setIsSidebarExpanded={setIsSidebarExpanded}
          />
        </header>

        {/* Main content */}
        <main
          className="flex-1 p-3 overflow-y-auto"
          style={{ backgroundColor: "#f1f5fc" }}
        >
          <Breadcrumb />
          <Outlet />
        </main>
      </div>
    </div>
  );
}

// Reusable sidebar content
function renderSidebarContent(
  menuItems,
  open,
  setFinanceGridOpen,
  financeGridOpen,
  financeGridChild,
  setFinanceGridChild,
  pathname,
  userDetails,
) {
  return (
    <div className="flex flex-col h-full relative" style={{ height: "100vh", position: "relative" }}>
      <div
        className="overflow-y-auto scrollbar-thin px-2 py-3"
        style={{ 
          flex: "1 1 auto",
          paddingBottom: "90px",
          minHeight: 0
        }}
      >
        <List sx={{ py: 0 }}>
          {menuItems.map(
            (
              { icon, label, path, isActive, visible = true, subItems },
              index
            ) =>
              visible ? (
                subItems ? (
                  <React.Fragment key={index}>
                    <ListItemButton
                      onClick={() => setFinanceGridOpen(!financeGridOpen)}
                      sx={{
                        py: 1.2,
                        px: 2,
                        mb: 0.5,
                        borderRadius: 2,
                        bgcolor: isActive 
                          ? "linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)" 
                          : "transparent",
                        background: isActive 
                          ? "linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)" 
                          : "transparent",
                        color: isActive ? "#4f46e5" : "#475569",
                        fontWeight: isActive ? 600 : 500,
                        "&:hover": {
                          bgcolor: isActive 
                            ? "rgba(99, 102, 241, 0.15)" 
                            : "rgba(99, 102, 241, 0.08)",
                          background: isActive 
                            ? "linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)" 
                            : "rgba(99, 102, 241, 0.08)",
                          transform: "translateX(4px)",
                        },
                        transition: "all 0.2s ease-in-out",
                        borderLeft: isActive ? "3px solid #4f46e5" : "3px solid transparent",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 2 : 0,
                          justifyContent: "center",
                          color: isActive ? "#4f46e5" : "#64748b",
                        }}
                      >
                        {icon}
                      </ListItemIcon>
                      {open && (
                        <ListItemText 
                          primary={label}
                          primaryTypographyProps={{
                            fontSize: "0.95rem",
                            fontWeight: isActive ? 600 : 500,
                          }}
                        />
                      )}
                      {open && (
                        financeGridOpen ? (
                          <ExpandLessIcon sx={{ color: "#4f46e5", fontSize: 20 }} />
                        ) : (
                          <ExpandMoreIcon sx={{ color: "#64748b", fontSize: 20 }} />
                        )
                      )}
                    </ListItemButton>

                    {open && (
                      <Collapse
                        in={financeGridOpen}
                        timeout="auto"
                        unmountOnExit
                      >
                        <List disablePadding sx={{ pl: 2, mt: 0.5, bgcolor: "transparent" }}>
                          {subItems?.map(
                            ({ label: subLabel, subItems: nestedSubItems }) => (
                              <div key={subLabel}>
                                <ListItemButton
                                  onClick={() =>
                                    setFinanceGridChild(
                                      financeGridChild === subLabel
                                        ? ""
                                        : subLabel
                                    )
                                  }
                                  sx={{
                                    py: 0.8,
                                    px: 1.5,
                                    mb: 0.3,
                                    borderRadius: 1.5,
                                    color:
                                      financeGridChild === subLabel
                                        ? "#4f46e5"
                                        : "#64748b",
                                    fontWeight: financeGridChild === subLabel ? 600 : 500,
                                    "&:hover": {
                                      bgcolor: "rgba(99, 102, 241, 0.08)",
                                      color: "#4f46e5",
                                      transform: "translateX(2px)",
                                    },
                                    transition: "all 0.2s ease-in-out",
                                  }}
                                >
                                  <ListItemIcon
                                    sx={{
                                      minWidth: 0,
                                      mr: open ? 1.5 : 0,
                                      justifyContent: "center",
                                      color:
                                        financeGridChild === subLabel
                                          ? "#4f46e5"
                                          : "#94a3b8",
                                    }}
                                  >
                                    <SquareIcon sx={{ fontSize: 10 }} />
                                  </ListItemIcon>
                                  {open && (
                                    <ListItemText 
                                      primary={subLabel}
                                      primaryTypographyProps={{
                                        fontSize: "0.875rem",
                                        fontWeight: financeGridChild === subLabel ? 600 : 500,
                                      }}
                                    />
                                  )}
                                  {open && (
                                    financeGridChild === subLabel ? (
                                      <ExpandLessIcon sx={{ fontSize: 18, color: "#4f46e5" }} />
                                    ) : (
                                      <ExpandMoreIcon sx={{ fontSize: 18, color: "#94a3b8" }} />
                                    )
                                  )}
                                </ListItemButton>

                                <Collapse
                                  in={financeGridChild === subLabel}
                                  timeout="auto"
                                  unmountOnExit
                                >
                                  <List disablePadding sx={{ pl: 2, mt: 0.3 }}>
                                    {nestedSubItems?.map((nestedItem) => {
                                      const isNestedActive = pathname.includes(nestedItem.path);
                                      return (
                                        <ListItem
                                          key={nestedItem.label}
                                          disablePadding
                                          sx={{ mb: 0.2 }}
                                        >
                                          <ListItemButton
                                            component={Link}
                                            to={nestedItem.path}
                                            sx={{
                                              py: 0.6,
                                              px: 1.5,
                                              borderRadius: 1.5,
                                              color: isNestedActive
                                                ? "#4f46e5"
                                                : "#64748b",
                                              fontWeight: isNestedActive ? 600 : 400,
                                              bgcolor: isNestedActive
                                                ? "rgba(99, 102, 241, 0.1)"
                                                : "transparent",
                                              "&:hover": {
                                                bgcolor: isNestedActive
                                                  ? "rgba(99, 102, 241, 0.15)"
                                                  : "rgba(99, 102, 241, 0.06)",
                                                color: "#4f46e5",
                                                transform: "translateX(2px)",
                                              },
                                              transition: "all 0.2s ease-in-out",
                                            }}
                                          >
                                            <ListItemIcon
                                              sx={{
                                                minWidth: 0,
                                                mr: 1,
                                                justifyContent: "center",
                                              }}
                                            >
                                              <RadioButtonCheckedIcon
                                                sx={{
                                                  fontSize: 12,
                                                  color: isNestedActive
                                                    ? "#4f46e5"
                                                    : "#cbd5e1",
                                                }}
                                              />
                                            </ListItemIcon>
                                            {open && (
                                              <ListItemText
                                                primary={nestedItem.label}
                                                primaryTypographyProps={{
                                                  fontSize: "0.8125rem",
                                                  fontWeight: isNestedActive ? 600 : 400,
                                                }}
                                              />
                                            )}
                                          </ListItemButton>
                                        </ListItem>
                                      );
                                    })}
                                  </List>
                                </Collapse>
                              </div>
                            )
                          )}
                        </List>
                      </Collapse>
                    )}
                  </React.Fragment>
                ) : (
                  // <ListItem
                  //   key={index}
                  //   disablePadding
                  //   sx={{ display: "block",mt:0.5 }}
                  // >
                  //   <ListItemButton
                  //     component={Link}
                  //     to={path}
                  //     sx={{
                  //       minHeight: 48,
                  //       justifyContent: open ? "initial" : "center",
                  //       px: 2.5,
                  //       backgroundColor: isActive ? "#e9eef8" : " ",
                  //       borderRadius:2
                  //     }}
                  //   >
                  //     <ListItemIcon
                  //       sx={{
                  //         minWidth: 0,
                  //         mr: open ? 2 : "auto",
                  //         justifyContent: "center",
                  //         color: isActive ? "#4167f3" : "#373474",
                  //       }}
                  //     >
                  //       {icon}
                  //     </ListItemIcon>
                  //     {open && (
                  //       <ListItemText
                  //         primary={label}
                  //         sx={{
                  //           opacity: open ? 1 : 0,
                  //           color: isActive ? "#4167f3" : "#373474",
                  //         }}
                  //       />
                  //     )}
                  //   </ListItemButton>
                  // </ListItem>
                  <ListItem
                    key={index}
                    disablePadding
                    sx={{ display: "block", mt: 0.5 }}
                  >
                    {!open ? (
                      <Tooltip 
                        title={label} 
                        placement="right"
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "#1e293b",
                              fontSize: "0.75rem",
                              padding: "6px 12px",
                            }
                          },
                          arrow: {
                            sx: {
                              color: "#1e293b",
                            }
                          }
                        }}
                      >
                        <ListItemButton
                          component={Link}
                          to={path}
                          sx={{
                            minHeight: 48,
                            justifyContent: "center",
                            px: 2.5,
                            mb: 0.5,
                            backgroundColor: isActive 
                              ? "linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)" 
                              : "transparent",
                            background: isActive 
                              ? "linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)" 
                              : "transparent",
                            borderRadius: 2,
                            borderLeft: isActive ? "3px solid #4f46e5" : "3px solid transparent",
                            "&:hover": {
                              bgcolor: isActive 
                                ? "rgba(99, 102, 241, 0.15)" 
                                : "rgba(99, 102, 241, 0.08)",
                              background: isActive 
                                ? "linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)" 
                                : "rgba(99, 102, 241, 0.08)",
                              transform: "scale(1.05)",
                            },
                            transition: "all 0.2s ease-in-out",
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: "auto",
                              justifyContent: "center",
                              color: isActive ? "#4f46e5" : "#64748b",
                            }}
                          >
                            {icon}
                          </ListItemIcon>
                        </ListItemButton>
                      </Tooltip>
                    ) : (
                      <ListItemButton
                        component={Link}
                        to={path}
                        sx={{
                          minHeight: 48,
                          justifyContent: "initial",
                          px: 2.5,
                          mb: 0.5,
                          backgroundColor: isActive 
                            ? "linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)" 
                            : "transparent",
                          background: isActive 
                            ? "linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)" 
                            : "transparent",
                          borderRadius: 2,
                          borderLeft: isActive ? "3px solid #4f46e5" : "3px solid transparent",
                          fontWeight: isActive ? 600 : 500,
                          "&:hover": {
                            bgcolor: isActive 
                              ? "rgba(99, 102, 241, 0.15)" 
                              : "rgba(99, 102, 241, 0.08)",
                            background: isActive 
                              ? "linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)" 
                              : "rgba(99, 102, 241, 0.08)",
                            transform: "translateX(4px)",
                          },
                          transition: "all 0.2s ease-in-out",
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: 2,
                            justifyContent: "center",
                            color: isActive ? "#4f46e5" : "#64748b",
                          }}
                        >
                          {icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={label}
                          primaryTypographyProps={{
                            fontSize: "0.95rem",
                            fontWeight: isActive ? 600 : 500,
                          }}
                          sx={{
                            color: isActive ? "#4f46e5" : "#475569",
                          }}
                        />
                      </ListItemButton>
                    )}
                  </ListItem>
                )
              ) : null
          )}
        </List>

        <Box 
          className="flex justify-center items-center mt-4 mb-2 px-2"
          sx={{
            opacity: open ? 1 : 0,
            transition: "opacity 0.3s ease-in-out",
          }}
        >
          {open && (
            <img
              src={logo}
              alt="Logo"
              className="img-fluid"
              style={{
                minHeight: "50px",
                maxHeight: "120px",
                filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))",
              }}
            />
          )}
        </Box>
      </div>

      <div
        className={`sticky bottom-0 left-0 right-0 z-10 ${
          open ? "px-4 py-3" : "px-2 py-2"
        } border-t border-gray-200 bg-white shadow-lg`}
        style={{
          background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
        }}
      >
        <div className={`flex items-center ${!open && "justify-center"}`}>
          <Avatar
            alt={userDetails?.user_name}
            src="/path/to/avatar.jpg"
            sx={{
              width: open ? 42 : 36,
              height: open ? 42 : 36,
              transition: "all 0.3s ease-in-out",
              background: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)",
              boxShadow: "0 2px 8px rgba(79, 70, 229, 0.3)",
              border: "2px solid white",
              "&:hover": {
                transform: "scale(1.05)",
                boxShadow: "0 4px 12px rgba(79, 70, 229, 0.4)",
              },
            }}
          >
            {userDetails?.user_name?.charAt(0)?.toUpperCase() || "U"}
          </Avatar>
          {open && (
            <div className="flex flex-col ml-3 min-w-0">
              <span className="text-sm font-semibold text-gray-800 truncate">
                {userDetails?.user_name || "NA"}
              </span>
              <span className="text-xs text-gray-500 truncate">
                {userDetails?.user_category || "NA"}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
